import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { FirmarComponent } from '../firmar/firmar.component';
import { RechazarComponent } from '../rechazar/rechazar.component';
import { ProcesoFirma } from '../../interfaces/datos-firma-interface';
import { DatosProcesarFirma } from '../../Models/Proceso-Firma-Datos.models';

@Component({
  selector: 'app-boton-accion',
  templateUrl: './boton-accion.component.html',
  styleUrls: ['./boton-accion.component.css']
})
export class BotonAccionComponent implements OnInit {

  @Input() datosProceso: ProcesoFirma;
  datos: DatosProcesarFirma;
  puedeFirmar: boolean = true;

  constructor(public dialog: MatDialog, private router: Router) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: any): void {
    if(changes['datosProceso'] && this.datosProceso) {
      var datosParticipante = this.datosProceso.participantesProcesoFirma.find(x => x.style === 'habilitado');
      
      if (datosParticipante) {
        this.datos = new DatosProcesarFirma(
          this.datosProceso._id, 
          datosParticipante.rut, 
          datosParticipante.tokenParticipante, 
          datosParticipante.emailParticipante,
          datosParticipante.tipoParticipante
        );
        
        if (this.datosProceso.estadoProcesoFirma.estatus === 'CANCELLED') {
          this.puedeFirmar = false;
        }
      }
    }
  }

  openDialog(tipo:string): void {
    let dialogRef;
    if(tipo === 'firmar') {
      dialogRef = this.dialog.open(FirmarComponent, {
        width: '600px',
        data: this.datos
      });
    } else {
      dialogRef = this.dialog.open(RechazarComponent, {
        width: '600px',
        data: this.datos
      });
    }    

    dialogRef.afterClosed().subscribe(result => {

      switch(result) {
        case 'firmado':
          this.router.navigate(['/resultado', 1]);  
          break;
        case 'rechazo':
          this.router.navigate(['/resultado', 2]);
          break;
        case 'error':
          this.router.navigate(['/resultado', 6]);
          break;
      }
      console.log('Se cierra dialog');
    });
  }

}
